var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusInBlueCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.162109 23.5293C0.162109 10.6151 10.6312 0.145996 23.5454 0.145996C36.4597 0.145996 46.9288 10.6151 46.9288 23.5293C46.9288 36.4436 36.4597 46.9127 23.5454 46.9127C10.6312 46.9127 0.162109 36.4436 0.162109 23.5293Z",
    fill: "#59B5CD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4925 29.1988V17.6774H25.9801V29.1988H22.4925ZM18.4756 25.1819V21.6943H29.9971V25.1819H18.4756Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusInBlueCircle);
export default __webpack_public_path__ + "static/media/plus-in-blue-circle.b0e4a18aa5bb2f87dbd26592c44254c7.svg";
export { ForwardRef as ReactComponent };